import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';

import { InputStyled, FormItemStyled, Checkbox } from './RewardForm.style';
import { ReactComponent as UserCircleSVG } from '../../assets/icons/user-circle.svg';
import { ReactComponent as Winner01 } from '../../assets/icons/winner-01.svg';
import { FieldArray, FormikProps } from 'formik';
import { RewardFormValues } from './RewardForm';
const { Text } = Typography;


interface Props {
    validateRequired: (value: string) => string | undefined;
    formikProps: FormikProps<RewardFormValues>,
}

const validatePhoneNumber = (value: string): string | undefined => {
  const phoneNumberRegex = /^[\d\s.\-+]+$/u;
  return phoneNumberRegex.test(value)
    ? undefined
    : 'numéro de téléphone invalide';
};

export const PhysicalOlympicGamesRewardForm: React.FunctionComponent<Props> = ({ validateRequired, formikProps }) => {

  return (
    <>
      <Row style={{ margin: '2rem 0' }}>
        <Col span={2}>
          <Winner01 style={{ width: '1.5rem', height: '1.5rem' }}/>
        </Col>
        <Col>
          <Text strong style={{ color: 'black' }}>
            Coordonnées du gagnant
          </Text>
        </Col>
      </Row>

      <FormItemStyled
        name="firstName"
        label="Prénom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="firstName" placeholder="Martin" />
      </FormItemStyled>
      <FormItemStyled
        name="lastName"
        label="Nom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="lastName" placeholder="Dupont" />
      </FormItemStyled>
      <FormItemStyled
        name="phone"
        label="Téléphone"
        required
        validate={(value) => validateRequired(value) ?? validatePhoneNumber(value)}
        labelCol={{ span: 24 }}
        tooltip="Votre numéro est obligatoire pour le suivi de votre livraison"
      >
        <InputStyled name="phone" placeholder="+33 06 45 45 45 45" />
      </FormItemStyled>
      <FormItemStyled
        name="email"
        label="Adresse e-mail"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="email" placeholder="martindupont@gmail.com" />
      </FormItemStyled>
      <FormItemStyled
        name="address"
        label="Adresse"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="address" placeholder="8 rue Jules Ferry" />
      </FormItemStyled>
      <FormItemStyled
        name="additionalAddress"
        label="Complément d'adresse"
        labelCol={{ span: 24 }}
      >
        <InputStyled name="additionalAddress" placeholder="3ème étage, porte B" />
      </FormItemStyled>
      <Row>
        <Col span={8}>
          <FormItemStyled
            name="zipCode"
            label="Code postal"
            required
            validate={validateRequired}
            labelCol={{ span: 24 }}
          >
            <InputStyled name="zipCode" placeholder="75001" />
          </FormItemStyled>
        </Col>
        <Col span={15} offset={1}>
          <FormItemStyled
            name="city"
            label="Ville"
            required
            validate={validateRequired}
            labelCol={{ span: 24 }}
          >
            <InputStyled name="city" placeholder="Paris" />
          </FormItemStyled>
        </Col>
      </Row>
      <Divider />
      <FieldArray name="recipients">
        {() => {
          return (
            <>
              <Row style={{ margin: '2rem 0' }}>
                <Col span={2}>
                  <UserCircleSVG style={{ width: '1.5rem', height: '1.5rem' }}/>
                </Col>
                <Col>
                  <Text strong style={{ color: 'black' }}>
                    Titulaire du billet n°1
                  </Text>
                </Col>
              </Row>
              <Row style={{ margin: '2rem 0' }}>
                <Col>
                  <Checkbox
                    onChange={(event): void => {
                      if (event.target.checked) {
                        formikProps.setFieldValue('recipients.0.firstName', formikProps.values.firstName);
                        formikProps.setFieldValue('recipients.0.lastName', formikProps.values.lastName);
                      }
                    }}
                  >
                    Même personne que le gagnant
                  </Checkbox>
                </Col>
              </Row>
              <FormItemStyled
                name="recipients.0.firstName"
                label="Prénom"
                required
                validate={validateRequired}
                labelCol={{ span: 24 }}
              >
                <InputStyled name="recipients.0.firstName" placeholder="Martin" />
              </FormItemStyled>
              <FormItemStyled
                name="recipients.0.lastName"
                label="Nom"
                required
                validate={validateRequired}
                labelCol={{ span: 24 }}
              >
                <InputStyled name="recipients.0.lastName" placeholder="Dupont" />
              </FormItemStyled>
              <Row style={{ margin: '2rem 0' }}>
                <Col span={2}>
                  <UserCircleSVG style={{ width: '1.5rem', height: '1.5rem' }}/>
                </Col>
                <Col>
                  <Text strong style={{ color: 'black' }}>
                    Titulaire du billet n°2
                  </Text>
                </Col>
              </Row>
              <FormItemStyled
                name="recipients.1.firstName"
                label="Prénom"
                required
                validate={validateRequired}
                labelCol={{ span: 24 }}
              >
                <InputStyled name="recipients.1.firstName" placeholder="Corrine" />
              </FormItemStyled>
              <FormItemStyled
                name="recipients.1.lastName"
                label="Nom"
                required
                validate={validateRequired}
                labelCol={{ span: 24 }}
              >
                <InputStyled name="recipients.1.lastName" placeholder="Delamare" />
              </FormItemStyled>
            </>
          );
        }}
      </FieldArray>

    </>
  );
};
